module.exports = __webpack_public_path__ + "img/vip-coupon.37a2a303.png";